import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Grid,
  MenuItem,
  Switch,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { Component } from "react";

import SectorFamilyService from "../../tools/SectorFamilyService";
import TreatmentsService from "../../tools/TreatmentsService";
import UserService from "../../tools/UserService";

//date
import "moment/locale/pt-br";

//msgs
import { connect } from "react-redux";
import { msgSimple } from "../../actions/snackbarActions";

//alerta
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";

const MySwal = withReactContent(Swal);

class UserModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      open: "",
      user: {
        id: "new",
        first_name: "",
        last_name: "",
        active: true,
        email: "",
        password: "",
        profile: "",
        phone1: "",
      },
      profiles: [
        "Administração",
        "Coordenação",
        "Manutenção",
        "Operações",
        "Solicitante",
      ],
      sectors: [],
      treatments: [],
    };
  }

  handleSave = () => {
    this.setState({ loading: true });
    if (this.state.user.id === "new") {
      delete this.state.user.id;
      if (this.state.user.profile === "Passageiro") {
        UserService.createPax(this.state.user).then((result) => {
          this.setState({ loading: false });
          if (result.ok) {
            this.props.msgSimple(
              this.state.user.first_name + " criado com sucesso."
            );
            this.props.func();
            if (this.props.createNewPax)
              this.props.createNewPax(result.response);
          } else {
            let { user } = this.state;
            this.props.msgSimple(
              'Erro ao criar "' +
                this.state.user.first_name +
                '". ' +
                result.message
            );
            this.setState({ user: { ...user, id: "new" } });
          }
        });
      } else {
        UserService.create(this.state.user).then((result) => {
          this.setState({ loading: false });
          if (result.ok) {
            this.props.msgSimple(
              this.state.user.first_name +
                " " +
                this.state.user.last_name +
                " criado com sucesso."
            );
            this.props.func();
          } else {
            console.log("result error:", result);
            let { user } = this.state;
            this.props.msgSimple(
              'Erro ao criar "' +
                this.state.user.first_name +
                '". ' +
                result.error.message
            );
            this.setState({ user: { ...user, id: "new" } });
          }
        });
      }
    } else {
      UserService.update(this.state.user.id, this.state.user).then((result) => {
        this.setState({ loading: false });
        if (result.ok) {
          this.props.msgSimple(
            this.state.user.first_name + " atualizado com sucesso."
          );
          this.props.func();
        } else {
          this.props.msgSimple(
            'Erro ao atualizar "' + this.state.user.first_name + '"'
          );
        }
      });
    }
  };

  onRender = () => {
    let { user } = this.state;

    if (this.props.createNewPax) {
      this.setState({
        profiles: ["Passageiro"],
      });
    } else
      this.setState({
        profiles: [
          "Administração",
          "Coordenação",
          "Manutenção",
          "Operações",
          "Solicitante",
        ],
      });
    this.setState({ loading: true });
    SectorFamilyService.getActive().then((result) => {
      // this.setState({ loading: false })
      if (result.ok) {
        this.setState({ sectors: result.response });
      }
    });

    TreatmentsService.getActive().then((result) => {
      // this.setState({ loading: false })
      if (result.ok) {
        this.setState({ treatments: result.response });
      }
    });

    if (this.props.id !== "new") {
      UserService.getById(this.props.id).then((result) => {
        this.setState({ loading: false });
        if (result.ok) {
          this.setState({ user: result.response });
        }
      });
    } else {
      // this.setState({ loading: false })
      let time = setInterval(() => {
        this.setState({
          user: {
            id: "new",
            first_name: "",
            active: true,
            email: "",
            profile: this.props.createNewPax ? "Passageiro" : "",
            last_name: "",
            phone1: "",
          },
          loading: false,
        });
        clearInterval(time);
      }, 700);
    }
  };

  render() {
    return (
      <Dialog
        // style={{ overflowX: 'hidden' }}
        open={this.props.openModal}
        onRendered={this.onRender}
        scroll={"body"}
        aria-labelledby="scroll-dialog-title"
      >
        <DialogContent>
          <Dialog open={this.state.loading}>
            <DialogContent>
              <CircularProgress></CircularProgress>
            </DialogContent>
          </Dialog>
          <Grid container>
            <Grid item container xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography variant="title" id="modal-title">
                {this.props.id === "new" ? "Novo Usuário" : "Editar Usuário"}
              </Typography>
            </Grid>
            <Grid item container xs={12} sm={12} md={12} lg={12} xl={12}>
              <Typography
                style={{ marginTop: 14, marginRight: 10 }}
                variant="subheading"
                id="modal-title"
              >
                Ativo:
              </Typography>
              <FormControlLabel
                control={
                  <Switch
                    id="active"
                    checked={this.state.user.active}
                    onChange={(event) => {
                      let { user } = this.state;
                      this.setState({
                        user: { ...user, active: event.target.checked },
                      });
                    }}
                    color="primary"
                  />
                }
              />
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              container
              spacing={8}
            >
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <TextField
                  id="first_name"
                  label="Nome*"
                  style={{ width: "100%" }}
                  value={this.state.user.first_name}
                  onChange={(event) => {
                    let { user } = this.state;
                    this.setState({
                      user: { ...user, first_name: event.target.value },
                    });
                  }}
                  margin="normal"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <TextField
                  label="Sobrenome*"
                  style={{ width: "100%" }}
                  value={this.state.user.last_name}
                  onChange={(event) => {
                    let { user } = this.state;
                    this.setState({
                      user: { ...user, last_name: event.target.value },
                    });
                  }}
                  margin="normal"
                />
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              container
              spacing={8}
            >
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <TextField
                  label="E-mail* (Login)"
                  style={{ width: "100%" }}
                  value={this.state.user.email}
                  onChange={(event) => {
                    let { user } = this.state;
                    this.setState({
                      user: { ...user, email: event.target.value },
                    });
                  }}
                  margin="normal"
                />
              </Grid>
              {this.state.user.id == "new" && <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <TextField
                  label="Senha* (Login)"
                  style={{ width: "100%" }}
                  value={this.state.user.password}
                  onChange={(event) => {
                    let { user } = this.state;
                    this.setState({
                      user: { ...user, password: event.target.value },
                    });
                  }}
                  margin="normal"
                />
              </Grid>}
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <TextField
                  id="phone1"
                  label="Celular*"
                  style={{ width: "100%" }}
                  value={this.state.user.phone1}
                  onChange={(event) => {
                    let { user } = this.state;
                    this.setState({
                      user: { ...user, phone1: event.target.value },
                    });
                  }}
                  margin="normal"
                />
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={12}
              lg={12}
              xl={12}
              container
              spacing={8}
            >
              <Grid item xs={12} sm={12} md={12} lg={6} xl={6}>
                <TextField
                  select
                  label="Perfil*"
                  style={{ width: "100%" }}
                  value={this.state.user.profile}
                  onChange={(event) => {
                    let { user } = this.state;
                    this.setState({
                      user: { ...user, profile: event.target.value },
                    });
                  }}
                  margin="normal"
                >
                  <MenuItem disabled>Selecione o Perfil</MenuItem>
                  {this.state.profiles &&
                    this.state.profiles.map((profile) => (
                      <MenuItem key={profile} value={profile}>
                        {profile}
                      </MenuItem>
                    ))}
                </TextField>
              </Grid>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button
            color="secondary"
            onClick={() => {
              Swal.fire({
                title:
                  this.state.user.id !== "new"
                    ? "<strong>Deseja sair sem salvar as alterações realizadas?</strong>"
                    : "<strong>Deseja sair sem salvar esse novo usuário?</strong>",
                type: "info",
                showCloseButton: true,
                showCancelButton: true,
                focusConfirm: false,
                confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim',
                confirmButtonAriaLabel: "Sim",
                cancelButtonText: '<i class="fa fa-thumbs-down"></i> Não',
                cancelButtonAriaLabel: "Não",
              }).then(async (result) => {
                if (!!result.value) {
                  this.setState({
                    user: {
                      id: "new",
                      first_name: "",
                      active: true,
                      email: "",
                      profile: "",
                      last_name: "",
                      phone1: "",
                    },
                  });
                  this.props.func();
                } else {
                }
              });
            }}
          >
            Cancelar
          </Button>
          <Button
            color="primary"
            onClick={() => {
              if (this.state.user.id === "new" && (this.state.user.password === "" || this.state.user.password === undefined)) {
                this.props.msgSimple("Preencha os campos obrigatórios.");
              }
              else if (
                this.state.user.first_name !== "" &&
                this.state.user.last_name !== "" &&
                this.state.user.phone1 !== "" &&
                this.state.user.email !== "" &&
                this.state.user.profile !== ""
              ) {
                Swal.fire({
                  title:
                    this.state.user.id !== "new"
                      ? "<strong>Deseja salvar as alterações realizadas?</strong>"
                      : "<strong>Deseja salvar esse novo usuário?</strong>",
                  type: "info",
                  showCloseButton: true,
                  showCancelButton: true,
                  focusConfirm: false,
                  confirmButtonText: '<i class="fa fa-thumbs-up"></i> Sim',
                  confirmButtonAriaLabel: "Sim",
                  cancelButtonText: '<i class="fa fa-thumbs-down"></i> Não',
                  cancelButtonAriaLabel: "Não",
                }).then(async (result) => {
                  if (!!result.value) {
                    this.handleSave(this.state.user);
                  } else {
                  }
                });
              } else this.props.msgSimple("Preencha os campos obrigatórios.");
            }}
          >
            Salvar
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = {
  msgSimple,
};

export default connect(mapStateToProps, mapDispatchToProps)(UserModal);



// WEBPACK FOOTER //
// ./src/modal/users/index.js